<!-- mobile intro card -->
<pipeline-intro-card *ngIf="!view.isDesktop && (!config || !config.uiMode) && (config.uiMode !== 'widget')"
  [(view)]="view.introCard" [hidden]="view.introCard.hidden"></pipeline-intro-card>

<ion-popover #daniChatSettingsPopover [isOpen]="isSettingsPopoverOpen" (didDismiss)="isSettingsPopoverOpen = false">
  <ng-template>
    <ion-content>
      <ion-list *ngIf="!!view.addActions">

        <ion-item button class="btn-item" *ngFor="let option of view.addActions"
          (click)="runItemSelectionOption(view.item, option)" [class.danger]="option.uid === 'delete'">
          <ion-icon [name]="option.icon" slot="start"></ion-icon>
          <ion-label [innerHTML]="option.label|translate"></ion-label>
        </ion-item>

      </ion-list>
    </ion-content>
  </ng-template>
</ion-popover>

<ion-grid [class.widget]="config.uiMode === 'widget'" [class.mini]="!!config.mini" [class.hasChat]="!!config.hasChat"
  [class.userCanWrite]="!!config.userCanWrite">

  <ion-row>

    <ion-col *ngIf="!!view.splineOptions"
      [size]="!config || !config.uiMode || (config.uiMode !== 'widget') ? (view.isDesktop ? 6 : 12) : 12"
      class="spline-col" [class.full-width]="!!config && (!!config.uiMode || (config.uiMode === 'widget'))"
      [class.has-messages]="state.hasMessages" [class.inConversation]="state.inConversation">

      <!-- dani preview -->
      <pipeline-spline-viewer [class]="view.animationClass" [(options)]="view.splineOptions"
        (click)="toChatPage()"></pipeline-spline-viewer>

    </ion-col>

    <ion-col *ngIf="!!config.hasChat || (!!view.introCard && !view.introCard.hidden) || !!config.userCanWrite"
      class="chat-col" [class.has-messages]="state.hasMessages" [class.inConversation]="state.inConversation"
      [size]="!config || !config.uiMode || (config.uiMode !== 'widget') ? (view.isDesktop ? 6 : 12) : 12"
      [class.full-width]="!!config && (!!config.uiMode || (config.uiMode === 'widget'))"
      [hidden]="view.introCard.hidden && (!view.chat || !config.hasChat)">

      <!-- chat -->
      <div id="daniChat" [class.widget]="!!config && !!config.uiMode && (config.uiMode === 'widget')" #daniChat
        *ngIf="!!view.chat && !!config.hasChat || (!!view.isDesktop && (!config || !config.uiMode || (config.uiMode !== 'widget')))">

        <!-- desktop intro card -->
        <pipeline-intro-card *ngIf="!!view.isDesktop && (!config || !config.uiMode) && (config.uiMode !== 'widget')"
          [(view)]="view.introCard" [hidden]="view.introCard.hidden"></pipeline-intro-card>

        <div class="history-wrapper" #historyWrapper *ngIf="!!view.chat && !!view.chat.length">
          <ion-card *ngFor="let message of view.chat; let iChatMessage = index; trackBy:trackItems"
            [class.system]="message.role === 'system'" [class.me]="message.role === 'user'"
            [class.dani]="message.role === 'assistant'">

            <ion-item class="message" class="ion-text-wrap" lines="none">

              <ion-icon [name]="message.icon" *ngIf="!!message.icon" slot="start"></ion-icon>

              <!-- classic message -->
              <ion-label class="ion-text-wrap" *ngIf="message.mode !== 'input'">
                <h3 [innerHTML]="message.input|translate" class="ion-text-wrap"></h3>
              </ion-label>

              <!-- input (forms) -->
              <ion-textarea *ngIf="(message.mode === 'input') && (message.type === 'textarea')" rows="5"
                [(ngModel)]="message.value" [placeholder]="(message.placeholder || message.name)|translate"
                [label]="message.name|translate" labelPlacement="stacked"></ion-textarea>

              <!-- textarea (forms) -->
              <ion-input *ngIf="(message.mode === 'input') && (message.type !== 'textarea')"
                [type]="message.type || 'text'" [(ngModel)]="message.value"
                [placeholder]="(message.placeholder || message.name)|translate" [label]="message.name|translate"
                labelPlacement="stacked"></ion-input>

              <ion-button slot="end" fill="clear" color="white" icon-only (click)="resend(message)"
                *ngIf="message.role === 'user'">
                <ion-icon name="sync-outline"></ion-icon>
              </ion-button>

            </ion-item>

            <ion-item *ngIf="!!iChatMessage && (message.mode === 'view') && (message.role === 'assistant')"
              lines="none">
              <pipeline-rate-item-buttons [(item)]="view.chat[iChatMessage]" type="message"
                slot="start"></pipeline-rate-item-buttons>
            </ion-item>

          </ion-card>
        </div>

        <!-- Write input form -->
        <form (ngSubmit)="send()">

          <ion-item lines="none" class="write-bar" [hidden]="!config.userCanWrite">

            <ion-button slot="start" icon-only color="primary" fill="clear" shape="round" (click)="addFile($event)">
              <ion-icon name="add-outline"></ion-icon>
            </ion-button>

            <ion-button slot="start" class="record-btn stop-record-btn" icon-only color="danger"
              (click)="stopListening()" fill="clear" [hidden]="!view.listening">
              <ion-icon name="stop-circle-outline" color="danger"></ion-icon>
            </ion-button>

            <ion-button slot="start" class="record-btn" icon-only (click)="record()" fill="clear" color="dark"
              [hidden]="!!view.listening || !view.speechRecognitionAvailable">
              <ion-icon name="mic-outline"></ion-icon>
            </ion-button>

            <ion-input name="aiPrompt" [autocorrect]="'on'" [disabled]="state.speaking" [(ngModel)]="view.aiPrompt"
              type="text" [placeholder]="'ask_dani'|translate"></ion-input>

            <ion-spinner slot="end" [hidden]="!view.loading"></ion-spinner>

            <ion-button slot="end" icon-only color="primary" (click)="send()" shape="round"
              [disabled]="!!view.blockRunAiPrompt || !view.aiPrompt || !!view.loading">
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </ion-button>

          </ion-item>

        </form>

      </div>

    </ion-col>

  </ion-row>
</ion-grid>